import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCollapse = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M9.784 10.934h13.2a.22.22 0 0 0 .22-.22v-1.54a.22.22 0 0 0-.22-.22h-13.2a.22.22 0 0 0-.22.22v1.54c0 .121.1.22.22.22Zm-.22 5.61c0 .121.1.22.22.22h13.2a.22.22 0 0 0 .22-.22v-1.54a.22.22 0 0 0-.22-.22h-13.2a.22.22 0 0 0-.22.22v1.54ZM23.424 3.18H1.864a.22.22 0 0 0-.22.22v1.54c0 .121.1.22.22.22h21.56a.22.22 0 0 0 .22-.22V3.4a.22.22 0 0 0-.22-.22Zm0 17.38H1.864a.22.22 0 0 0-.22.22v1.54c0 .121.1.22.22.22h21.56a.22.22 0 0 0 .22-.22v-1.54a.22.22 0 0 0-.22-.22ZM1.738 13.05l4.298 3.385c.16.127.396.014.396-.19v-6.77a.244.244 0 0 0-.396-.19L1.738 12.67a.24.24 0 0 0 0 .38Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCollapse)
const Memo = memo(ForwardRef)
export default Memo
